import {
  ReadonlyBaseballBallToken,
  ReadonlyBaseballPlayerToken,
  ReadonlyBasketballPlayerToken,
  ReadonlyConeToken,
  ReadonlyCricketPlayerToken,
  ReadonlyCustomPlayerToken,
  ReadonlyFlagToken,
  ReadonlyHoopToken,
  ReadonlyHurdleToken,
  ReadonlyIceHockeyPlayerToken,
  ReadonlyPlainColorToken,
  ReadonlyPoleToken,
  ReadonlyRugbyPlayerToken,
  ReadonlySoccerPlayerToken,
  ReadonlyToken,
  ReadonlyVolleyballPlayerToken,
  TokenType,
  TokenVisitor,
} from "@sportactics/board-editing";

import { BaseTokenModel, TokenModel } from "./token-model";

export function convertTokenToModel(token: ReadonlyToken): TokenModel {
  return TokenModelConverter.getInstance().visit(token);
}

class TokenModelConverter extends TokenVisitor<TokenModel> {
  private static readonly instance = new TokenModelConverter();

  protected visitVolleyballBall(token: ReadonlyToken): TokenModel {
    return {
      type: TokenType.VolleyballBall,
      ...this.convertBaseToken(token),
    };
  }

  protected visitVolleyballPlayer(
    token: ReadonlyVolleyballPlayerToken,
  ): TokenModel {
    return {
      type: TokenType.VolleyballPlayer,
      ...this.convertBaseToken(token),
      team: token.team,
      role: token.role,
    };
  }

  protected visitBasketballBall(token: ReadonlyToken): TokenModel {
    return {
      type: TokenType.BasketballBall,
      ...this.convertBaseToken(token),
    };
  }

  protected visitBasketballPlayer(
    token: ReadonlyBasketballPlayerToken,
  ): TokenModel {
    return {
      type: TokenType.BasketballPlayer,
      ...this.convertBaseToken(token),
      team: token.team,
      playerPosition: token.playerPosition,
    };
  }

  protected visitSoccerBall(token: ReadonlyToken): TokenModel {
    return {
      type: TokenType.SoccerBall,
      ...this.convertBaseToken(token),
    };
  }

  protected visitSoccerPlayer(token: ReadonlySoccerPlayerToken): TokenModel {
    return {
      type: TokenType.SoccerPlayer,
      team: token.team,
      playerPosition: token.playerPosition,
      ...this.convertBaseToken(token),
    };
  }

  protected visitIceHockeyPuck(token: ReadonlyToken): TokenModel {
    return {
      type: TokenType.IceHockeyPuck,
      ...this.convertBaseToken(token),
    };
  }

  protected visitIceHockeyPlayer(
    token: ReadonlyIceHockeyPlayerToken,
  ): TokenModel {
    return {
      type: TokenType.IceHockeyPlayer,
      team: token.team,
      playerPosition: token.playerPosition,
      ...this.convertBaseToken(token),
    };
  }

  protected visitRugbyBall(token: ReadonlyToken): TokenModel {
    return {
      type: TokenType.RugbyBall,
      ...this.convertBaseToken(token),
    };
  }

  protected visitRugbyPlayer(token: ReadonlyRugbyPlayerToken): TokenModel {
    return {
      type: TokenType.RugbyPlayer,
      team: token.team,
      playerPosition: token.playerPosition,
      ...this.convertBaseToken(token),
    };
  }

  protected visitBaseballBall(token: ReadonlyBaseballBallToken): TokenModel {
    return {
      type: TokenType.BaseballBall,
      ...this.convertBaseToken(token),
    };
  }

  protected visitBaseballPlayer(
    token: ReadonlyBaseballPlayerToken,
  ): TokenModel {
    return {
      type: TokenType.BaseballPlayer,
      playerPosition: token.playerPosition,
      ...this.convertBaseToken(token),
    };
  }

  protected visitCricketBall(token: ReadonlyToken): TokenModel {
    return {
      type: TokenType.CricketBall,
      ...this.convertBaseToken(token),
    };
  }

  protected visitCricketPlayer(token: ReadonlyCricketPlayerToken): TokenModel {
    return {
      type: TokenType.CricketPlayer,
      team: token.team,
      ...this.convertBaseToken(token),
    };
  }

  protected visitCustomPlayer(token: ReadonlyCustomPlayerToken): TokenModel {
    return {
      type: TokenType.CustomPlayer,
      number: token.number,
      name: token.name,
      ...this.convertBaseToken(token),
    };
  }

  protected visitCone(token: ReadonlyConeToken): TokenModel {
    return {
      type: TokenType.Cone,
      color: token.color,
      ...this.convertBaseToken(token),
    };
  }

  protected visitFlag(token: ReadonlyFlagToken): TokenModel {
    return {
      type: TokenType.Flag,
      color: token.color,
      ...this.convertBaseToken(token),
    };
  }

  protected visitHoop(token: ReadonlyHoopToken): TokenModel {
    return {
      type: TokenType.Hoop,
      color: token.color,
      ...this.convertBaseToken(token),
    };
  }

  protected visitHurdle(token: ReadonlyHurdleToken): TokenModel {
    return {
      type: TokenType.Hurdle,
      color: token.color,
      ...this.convertBaseToken(token),
    };
  }

  protected visitPole(token: ReadonlyPoleToken): TokenModel {
    return {
      type: TokenType.Pole,
      color: token.color,
      ...this.convertBaseToken(token),
    };
  }

  protected visitPlainColor(token: ReadonlyPlainColorToken): TokenModel {
    return {
      type: TokenType.PlainColor,
      color: token.color,
      ...this.convertBaseToken(token),
    };
  }

  private convertBaseToken(token: ReadonlyToken): BaseTokenModel {
    return {
      id: token.id,
      position: token.position,
      size: token.size,
    };
  }

  static getInstance(): TokenModelConverter {
    return this.instance;
  }
}
